import { css } from '@emotion/css'

import { breakpoint, fontFamily, fontSize, spacing } from '../../../styles'
import { mediaQueryHelper, shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'

const styles = {
  heading: css({
    marginBottom: spacing.extraSmall,
  }),

  list: css({
    marginTop: spacing.medium,
  }),

  cityList: css({
    padding: 0,
    margin: 0,
    marginLeft: '30px',
  }),

  cityItem: css({
    fontSize: fontSize.default,
    color: colors.scorpion,
    fontFamily: fontFamily.body,
    listStylePosition: 'outside',
    display: 'table',
    textAlign: 'left',
    '::before': {
      content: '"•"',
      display: 'table-cell',
      padding: shorthandHelper([0, spacing.small]),
      textAlign: 'left',
    },
  }),

  tooltip: css({
    display: 'inline-block',
    '> div': {
      width: `${breakpoint.desktop}px`,
      maxWidth: '100vw',
      [mediaQueryHelper(breakpoint.desktop)]: {
        width: 'max-content',
        maxWidth: 250,
      },
    },
  }),

  remoteItem: css({
    color: colors.oxfordBlue,
    fontFamily: fontFamily.body,
  }),
}

export default styles
